import { connectFetch } from "./utils";

const getJobPostById = async (token, jobPostId) => {
  return connectFetch("jobpost", token, `/${jobPostId}`);
};

export { getJobPostById };
